// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter';
import './i18n';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Initialize fonts
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <>
    <AppRouter />
    <ToastContainer position={'bottom-right'}/>
  </>
);